<template>
	<header>
		<h1 class="heading">Build Your Cutlist</h1>
	</header>
</template>

<script>
export default {};
</script>

<style scoped>
header {
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
	margin: 3rem auto;
	border-radius: 10px;
	padding: 1rem;
	background-color: transparent;
	color: var(--color-dark);
	text-align: center;
	width: 90%;
	max-width: 65rem;
}
</style>
